// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/descent-planning.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/descent-planning/descent-planning.js';

mount([g0]);
